// config.ts

// helpers to coerce env strings
const s = (v: string | undefined, d: string) => (v && v.trim()) || d;
const n = (v: string | undefined, d: number) => {
  const x = Number(v);
  return Number.isFinite(x) ? x : d;
};
const b = (v: string | undefined, d = false) =>
  v == null ? d : /^(1|true|yes|on)$/i.test(v.trim());

// base
export const DEFAULT_SKIN   = s(import.meta.env.VITE_DEFAULT_SKIN, "default");
export const DISPLAY_LOCALE = s(import.meta.env.VITE_DEFAULT_LOCALE, "en-GB");  // FIX: 1. local setting, 2. api setting, 3 env setting, 4 defaault
export const DISPLAY_TZ     = s(import.meta.env.VITE_DEFAULT_TZ, "Europe/Stockholm"); // FIX: 1. local setting, 2. api setting, 3 env setting, 4 defaault

// UI layout
export const UI_MTOP    = n(import.meta.env.VITE_DEFAULT_UI_MTOP, 20);
export const UI_MRIGHT  = n(import.meta.env.VITE_DEFAULT_UI_MRIGHT, 10);
export const UI_MBOTTOM = n(import.meta.env.VITE_DEFAULT_UI_MBOTTOM, 20);
export const UI_MLEFT   = n(import.meta.env.VITE_DEFAULT_UI_MLEFT, 10);
export const UI_MARGINS = Object.freeze({
  top: UI_MTOP, right: UI_MRIGHT, bottom: UI_MBOTTOM, left: UI_MLEFT,
});

// UI look
export const UI_COLOR    = s(import.meta.env.VITE_DEFAULT_UI_COLOR, "#FFFFFF");
export const UI_BGCOLOR  = s(import.meta.env.VITE_DEFAULT_UI_BGCOLOR, "#000000");
export const UI_MAXITEMS = n(import.meta.env.VITE_DEFAULT_UI_MAXITEMS, 99);
export const UI_SHOWGUIDES = b(import.meta.env.VITE_DEFAULT_UI_SHOWGUIDES, false);
export const UI_SHOWTIME   = b(import.meta.env.VITE_DEFAULT_UI_SHOWTIME, false);

// runtime/config
export const REFRESH_INTERVAL = n(import.meta.env.VITE_DEFAULT_CONFIG_REFRESH_INTERVAL, 60000);
export const API_KEY          = s(import.meta.env.VITE_DEFAULT_CONFIG_API_KEY, "");
export const PERMISSION_TYPE  = s(import.meta.env.VITE_DEFAULT_CONFIG_PERMISSION_TYPE, "BOARD");
export const MAX_MESSAGES     = n(import.meta.env.VITE_DEFAULT_CONFIG_MAX_MESSAGES, 35);

// optional: bundle for convenience
export const CONFIG = Object.freeze({
  DEFAULT_SKIN, DISPLAY_LOCALE, DISPLAY_TZ,
  UI_MARGINS, UI_COLOR, UI_BGCOLOR, UI_MAXITEMS, UI_SHOWGUIDES, UI_SHOWTIME,
  REFRESH_INTERVAL, API_KEY, PERMISSION_TYPE, MAX_MESSAGES,
});
